export const getCurrentDate = () => {
    var now = new Date();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
    return now.getDate() + " - " + monthNames[now.getMonth()] + " -" + now.getFullYear();
}
export const randGen = () => {
    const list = "ABCDEFGHIJKLMNPQRSTUVWXYZ123456789";
    var res = "";
    for (var i = 0; i < 12; i++) {
        var rnd = Math.floor(Math.random() * list.length);
        res = res + list.charAt(rnd);
    }
    return res;
}

export const getMaskedPhone = (phonenum) => {
    if (phonenum !== undefined && phonenum !== null) {
        let first3 = phonenum.substring(0, 3);
        let last3 = phonenum.substring(phonenum.length - 3);
        let mask = phonenum.substring(4, phonenum.length - 2).replace(/\d/g, "*");
        return first3 + " " + mask + " " + last3;
    }
    return "07 ****** "

}


export const currencyFormatter = (amount) => {
    return parseFloat(amount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
export const getUriRef = (uri) => {
    switch (uri) {
        case 'login':
            return 1;
        case 'verify':
        case 'select-products':
        case 'summary':
            return 2;
        case 'transactions':
            return 5;
        default:
            return 2;

    }

}
export const validSession = (logtime) => {
    const time = new Date();
    let now = time.getTime();
    let mins = (now - logtime)/60000;
    const tim = Math.ceil(mins)
    if (tim < 50) {
        return true 
    }
    return false
}

export const printerD = (a, b, c, d) => {
    // let childwin
    // localStorage.setItem('userInfo', JSON.stringify(b));
    // childwin = window.open('/pdf', "popup", 'height=300px, width=500px');
    console.log(JSON.stringify(b))
}
export const ASSETS_PATH = '../src/assets/';


